import { useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import Map from '../../components/google/maps/Map';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { useFields } from '../../hooks/use-fields';

export default function RxGoogleMap(props) {
  const { filters, ...rest } = props;
  const growerId = useSelector(growerSelectors.selectedId);
  const { focusAaid, selectedAaids, bounds } = useFields();

  const compositeFilters = useMemo(
    () => ({ growerId, ...filters }),
    [growerId, filters],
  );

  const onFeatureClick = useCallback(
    (layer, aaid) => (layer === 'boundary' ? focusAaid(aaid) : null),
    [focusAaid],
  );

  return (
    <Map
      onClick={onFeatureClick}
      filters={compositeFilters}
      bounds={bounds}
      selectedFeatures={{ boundary: selectedAaids }}
      {...rest}
    />
  );
}
